import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { CgAddR } from "react-icons/cg";
import { TiUploadOutline } from "react-icons/ti";
import useUserAsset from "../../hooks/useUserAssets";
import { formatAmount } from "../../utils/formatTime";
import nairaLogo from "../../assets/images/Naira.svg";
import NairaRecentTnxn from "./NairaRecentTnxn";
import NairaDepositModal from "./NairaDepositModal";
import NairaWithdrawModal from "./NairaWithdrawModal";
import BillPaymentSection from "../dashboardPage/utilities/BillPaymentSection";

type NairaWalletProps = {
  setOpenCoin: (open: boolean) => void;
  selectedCoinObj: any;
  setSelectedCoinObj: (coin: any) => void;
};

const NairaWallet: React.FC<NairaWalletProps> = ({
  setOpenCoin,
  selectedCoinObj,
  setSelectedCoinObj,
}) => {
  const [openDeposit, setOpenDeposit] = useState(false);
  const [openWithdraw, setOpenWithdraw] = useState(false);
  const { walletBalance, loading } = useUserAsset();
  const ngnBalance = walletBalance?.ngn ?? 0;

  return (
    <div className="w-full px-4 pb-20 font-manrope md:px-12 mds:px-8 lgss:px-16 xxl:px-24 xxxl:px-36">
      <div className="mx-auto w-full max-w-xl">
        <button
          onClick={() => {
            setSelectedCoinObj(null);
            setOpenCoin(false);
          }}
          className="mb-6 flex items-center gap-2"
        >
          <BsArrowLeft className="text-[14px] text-gray-800 dark:text-[#D8D8D8]" />
        </button>

        <div className="w-full rounded-xl bg-white px-5 py-6 dark:bg-[#1C2227]">
          <div className="flex flex-col items-center text-center">
            <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-[#E8F3FC] dark:bg-[#1F2B36]">
              <img
                src={selectedCoinObj?.logo ?? nairaLogo}
                alt="Naira"
                className="h-9 w-9 object-contain"
              />
            </div>
            <h4 className="mt-3 font-sora text-[15px] font-semibold text-[#13181B] dark:text-gray-100">
              {selectedCoinObj?.name ?? "Naira"}
            </h4>
            <p className="text-[12px] font-medium text-gray-500 dark:text-gray-400">
              {selectedCoinObj?.abbr ?? "NGN"}
            </p>
          </div>

          <div className="mt-6 rounded-xl bg-[#F7FAFC] px-4 py-5 text-center dark:bg-[#151B20]">
            <p className="text-[13px] text-[#4E606E] dark:text-gray-400">
              Available balance
            </p>
            <p className="mt-1 font-sora text-[26px] font-bold leading-tight text-[#13181B] dark:text-gray-100">
              {loading ? "---" : `₦${formatAmount(ngnBalance)}`}
            </p>
          </div>

          <div className="mt-6 flex w-full items-center gap-3">
            <button
              type="button"
              onClick={() => setOpenDeposit(true)}
              className="flex h-[44px] w-1/2 items-center justify-center gap-2 rounded-lg bg-[#D4EBFD] text-[15px] font-semibold text-[#0B75C2] transition hover:brightness-95"
            >
              <CgAddR className="text-[16px]" />
              Deposit
            </button>
            <button
              type="button"
              onClick={() => setOpenWithdraw(true)}
              className="flex h-[44px] w-1/2 items-center justify-center gap-2 rounded-lg bg-[#D4EBFD] text-[15px] font-semibold text-[#0B75C2] transition hover:brightness-95"
            >
              <TiUploadOutline className="text-[16px]" />
              Withdraw
            </button>
          </div>
        </div>

        <BillPaymentSection />

        <NairaRecentTnxn />
      </div>

      {openDeposit && <NairaDepositModal setOpenDeposit={setOpenDeposit} />}
      {openWithdraw && <NairaWithdrawModal setOpenWithdraw={setOpenWithdraw} />}
    </div>
  );
};

export default NairaWallet;
